import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const winProngLight = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1,
  type: 'WindowsProngLight',
  associationType: 'ImagePRONG',
  stringKey: 'ImageExperience_Image_Ratio_1x1',
  imagePreviewHeight: 150,
  simplifiedType: 'ImagePRONG',
  className: 'app-ad-1X1',
  isRequired: true,
  minimumRequirements: 1,
  minSize: [300, 304],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('1:1 Windows Widgets Dashboard (Light mode)'),
    stringKey: _TL_('1:1 Windows Widgets Dashboard (Light mode)'),
  },
  previewSettings: {
    previewContentClassName: 'app-ad-1X1',
    showBusinessName: true,
    showBusinessNameFirst: true,
    showProngLight: true,
    showStart: false,
    showWinStore: false,
    hideLabel: true,
    showImage: true,
    showLogo: true,
    showShortHeadline: true,
  },
  styleOverrides: {
    cardParent: {
      borderRadius: 8,
      '& .responsive-ad-preview-content': {
        width: '418px !important',
        height: '300px !important',
        background: '#262632 !important',
      },
      '& .image-container': {
        position: 'absolute',
        // width: '100%',
        height: 150,
        width: 150,
        left: 77,
        top: 33,

        '& .cropped-image-view': {
          height: 152,
          width: 150,
          position: 'absolute',
          borderRadius: 8,
          border: '1px solid blue',
        },
      },
      '& .image-container:before': {
        background: 'linear-gradient(333.85deg, rgba(0, 0, 0, 0.9) 3.12%, rgba(4, 11, 37, 0.09) 73.66%)',
        content: '\'\'',
        width: '100%',
        height: '100%',
        display: 'block',
        position: 'absolute',
        zIndex: 1,
        borderRadius: 8,
      },
      '& .logo-container': {
        position: 'absolute',
        top: 39,
        left: 83,
        zIndex: 2,
        '& .cropped-image-view': {
          overflow: 'hidden',
          height: 'unset !important',
          width: 'unset !important',
          borderRadius: 8,
          '& img': {
            objectFit: 'cover',
            width: '70.5px !important',
            height: '70.5px !important',
          },
        },
      },
      '& .text-container-apl': {
        position: 'absolute',
        top: 128,
        left: 83,
        zIndex: 2,
        '& .short-headline': {
          position: 'absolute',
          top: 10,
          fontSize: 7,
          fontWeight: 300,
          width: 200,
          color: 'white',
          textVverflow: 'ellipsis',
          '-webkit-box-orient': 'vertical',
          '-webkit-line-clamp': 1,
          maxWidth: 140,
        },
        '& .business-name-with-ads': {
          position: 'absolute',
          top: 0,
          marginTop: 0,
          color: '#FFFFFF',
          fontWeight: 350,
          fontSize: 8,
          textVverflow: 'ellipsis',
          '-webkit-box-orient': 'vertical',
          '-webkit-line-clamp': 1,
          maxWidth: 140,
        },
      },
    },
  },
};

export default winProngLight;

